import { lazy } from 'react';
// CUSTOM COMPONENTS
import Loadable from './Loadable';
import { AuthGuard } from 'components/auth';
import DashboardAccessGuard from 'components/auth/DashboardAccessGuard';
import TripsAccessGuard from 'components/auth/TripsAccessGuard';
import LayoutV1 from 'layouts/layout-1';

const LevelOfService = Loadable(
  lazy(() => import('pages/dashboard/levelOfService/levelOfServices'))
);
const AddLevelOfService = Loadable(
  lazy(
    () => import('pages/dashboard/levelOfService/components/addLevelOfService')
  )
);

const Patients = Loadable(
  lazy(() => import('pages/dashboard/patients/patients'))
);
const AddEditPatient = Loadable(
  lazy(() => import('pages/dashboard/patients/components/addEditPatient'))
);

const AddEditTrip = Loadable(
  lazy(() => import('pages/dashboard/trips/components/tripCombineForm'))
);

const Trips = Loadable(lazy(() => import('pages/dashboard/trips/trips')));

const TripAllDetails = Loadable(
  lazy(
    () =>
      import('pages/dashboard/trips/components/tripAllDetails/tripAllDetails')
  )
);

const StandingOrders = Loadable(
  lazy(() => import('pages/dashboard/trips/standingOrders/standingOrders'))
);

const Quotes = Loadable(
  lazy(() => import('pages/dashboard/trips/quotes'))
);

const PatientDetails = Loadable(
  lazy(() => import('pages/dashboard/patients/patientDetails/patientlDetails'))
);

const EditUserInfo = Loadable(
  lazy(() => import('pages/admin/paymentsList/editUserInfo'))
);

const Dashboard = Loadable(
  lazy(() => import('pages/dashboard/dashboards/dashboard'))
);

export const DashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <LayoutV1 />
      </AuthGuard>
    ),
    children: [
      {
        path: '/dashboard',
        element: (
          <DashboardAccessGuard>
            <Dashboard />
          </DashboardAccessGuard>
        )
      },
      {
        path: 'edit-user-page',
        element: <EditUserInfo />
      },
      {
        path: 'level-of-service',
        element: <LevelOfService />
      },
      {
        path: 'add-new-level-of-service',
        element: <AddLevelOfService />
      },
      {
        path: 'patients',
        element: <Patients />
      },
      {
        path: 'add-new-patient',
        element: <AddEditPatient />
      },
      {
        path: 'edit-patient/:id',
        element: <AddEditPatient />
      },
      {
        path: 'patient-details/:id',
        element: <PatientDetails />
      },
      {
        path: 'add-trip',
        element: <AddEditTrip />
      },
      {
        path: 'edit-trip/:id',
        element: <AddEditTrip />
      },
      {
        path: 'duplicate-trip/:id',
        element: <AddEditTrip />
      },
      {
        path: 'trip-details/:id',
        element: <TripAllDetails />
      },
      {
        path: 'trips',
        element: (
          <TripsAccessGuard>
            <Trips />
          </TripsAccessGuard>
        )
      },
      {
        path: 'trips/:listType',
        element: (
          <TripsAccessGuard>
            <Trips />
          </TripsAccessGuard>
        )
      },
      {
        path: 'standing-orders/:tripId',
        element: <StandingOrders />
      },
      {
        path: 'quotes',
        element: (
          <TripsAccessGuard>
            <Quotes />
          </TripsAccessGuard>
        )
      },
      {
        path: 'quotes/:listType',
        element: (
          <TripsAccessGuard>
            <Quotes />
          </TripsAccessGuard>
        )
      }
    ]
  }
];
